module.exports = __webpack_public_path__ + "static/media/EventPhoto6.d5c9a8b0.jpg";